import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setVehicle,
  clearEditDoc,
  setListRefresh,
} from "features/documents/documentSlice";
import { fetchThingDetails } from "features/thing/thingThunk";

import { Grid, Autocomplete, Paper} from "@mui/material";
import axios from "axios";

// import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
// import MDAlert from "components/MDAlert";
// import MDProgress from "components/MDProgress";
import MDSnackbar from "components/MDSnackbar";

function UploadForm() {
  const [docName, setDocName] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [email, setEmail] = useState("");
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    color: "success",
  });

  const dispatch = useDispatch();
  const things = useSelector((state) => state.things.filterThing || []);
  const selectedVehicle = useSelector(
    (state) => state.document.selectedVehicle
  );
  const editDocuments = useSelector((state) => state.document.editDocuments);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    dispatch(fetchThingDetails());
  }, [dispatch]);

  useEffect(() => {
    if (editDocuments) {
      setDocName(editDocuments.documentName || "");
      setExpiryDate(editDocuments.documentExpireDate || "");
      setEmail(editDocuments.emailId || "");
      dispatch(setVehicle(editDocuments.vehicleId || null));
      setInputValue(editDocuments.vehicleName || "");
    } else {
      setDocName("");
      setExpiryDate("");
      setEmail("");
      setDocument(null);
      dispatch(setVehicle(null));
      setInputValue("");
    }
  }, [editDocuments, dispatch]);

  const vehicleOptions = things.map((t) => ({
    label: t.name || t.id,
    value: t.id,
  }));

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedVehicle || !docName || !expiryDate || !email) {
    setSnackbar({
      open: true,
      message: "Please fill all fields",
      color: "error",
    });
    return;
  }

  try {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
      setSnackbar({
        open: true,
        message: "No token found. Please log in first.",
        color: "error",
      });
      return;
    }

    let res;
    if (editDocuments) {
      const formData = new FormData();
      if (document) {
        formData.append("file", document);
      }
      formData.append("documentExpiryDate", expiryDate);
      formData.append("emailId", email);
      for (let [key, value] of formData.entries()) {
        console.log("Update FormData =>", key, value);
      }

      const url = `https://v3.dhundhoo.com/vehicles/${selectedVehicle}/documents/update?documentName=${encodeURIComponent(
        docName
      )}&documentId=${editDocuments.id}`;

      res = await axios.post(url, formData, {
        headers: {
          "x-dhundhoo-session": token,
          Accept: "application/json, text/plain, */*",
        },
      });

      dispatch(clearEditDoc());
    } else {
      // ---------- UPLOAD NEW DOCUMENT ----------
      const formData = new FormData();
      formData.append("file", document);
      formData.append("documentName", docName);
      formData.append("documentExpiryDate", expiryDate);
      formData.append("emailId", email);

      const url = `https://v3.dhundhoo.com/vehicles/${selectedVehicle}/documents/upload`;

      res = await axios.post(url, formData, {
        headers: {
          "x-dhundhoo-session": token,
          Accept: "application/json, text/plain, */*",
        },
      });
    }

    setSnackbar({
      open: true,
      message: editDocuments
        ? "Document updated successfully!"
        : "Document uploaded successfully!",
      color: "success",
    });

    dispatch(setListRefresh());
    setDocName("");
    setExpiryDate("");
    setEmail("");
    setDocument(null);
    setInputValue("");
  } catch (err) {
    setSnackbar({
      open: true,
      message: "Operation failed",
      color: "error",
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        borderRadius: 3,
        mx: "auto",
        boxShadow: "0px 4px 12px #fff",
      }}
    >
      <MDTypography
        variant="h5"
        fontWeight="600"
        gutterBottom
        sx={{
          color: "#1a237e",
          mb: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          textAlign: "center",
        }}
      >
        Upload Vehicle Document
      </MDTypography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Vehicle Autocomplete */}
          <Grid item xs={12} sm={6}>
            <Autocomplete
              freeSolo
              options={vehicleOptions}
              value={
                selectedVehicle
                  ? vehicleOptions.find((v) => v.value === selectedVehicle) ||
                    null
                  : null
              }
              onChange={(event, newValue) => {
                dispatch(setVehicle(newValue ? newValue.value : null));
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) =>
                setInputValue(newInputValue)
              }
              renderInput={(params) => (
                <MDInput
                  {...params}
                  label="Search Vehicle"
                  placeholder="Enter vehicle ID or name"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>

          {/* Document Name */}
          <Grid item xs={12} sm={6}>
            <MDInput
              label="Document Name"
              placeholder="e.g., Insurance, Registration"
              fullWidth
              required
              value={docName}
              onChange={(e) => setDocName(e.target.value)}
              size="small"
            />
          </Grid>

          {/* Expiry Date */}
          <Grid item xs={12} sm={6}>
            <MDInput
              label="Expiry Date"
              type="date"
              fullWidth
              required
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
            />
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6}>
            <MDInput
              label="Email ID"
              placeholder="Enter email for notifications"
              type="email"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              size="small"
            />
          </Grid>

          {/* File Upload */}
          <Grid item xs={12} sm={6}>
            <MDButton
              variant="outlined"
              component="label"
              fullWidth
              sx={{
                textTransform: "none",
                borderRadius: 2,
                height: 42,
                border: "1px solid #e3e3e3",
                color: "black !important",
                background: "#e3e3e3",
                "&:hover": {
                  border: "1px solid #e3e3e3",
                  background: "#e3e3e3",
                },
              }}
            >
              {document ? document.name : "Upload Document"}
              <input
                type="file"
                hidden
                onChange={(e) => setDocument(e.target.files[0])}
              />
            </MDButton>
          </Grid>

          {/* Submit */}
          <Grid item xs={12} sm={6}>
            <MDButton
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              color="warning"
              sx={{
                textTransform: "none",
                borderRadius: 2,
                height: 42,
              }}
            >
              {loading
                ? "Uploading..."
                : editDocuments
                ? "Update Document"
                : "Submit Document"}
            </MDButton>
          </Grid>
        </Grid>
      </form>

      {/* Snackbar for success/error */}
      <MDSnackbar
        color={snackbar.color}
        icon="notifications"
        title={snackbar.color === "success" ? "Success" : "Error"}
        content={snackbar.message}
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        close
      />
    </Paper>
  );
}

export default UploadForm;
